import type { ConnectionEditState } from "../../viewmodels/board/connections/Connections.types";
import { parseConnectionConfiguration } from "../source-settings/SourceSettingsConfiguration";

interface SharePointConfigurationValidationModel {
  doneStatus?: string;
  statusesToLoad?: string[];
}

export const getSharePointSourceSettingsValidationMessage = (
  editingConnection: ConnectionEditState,
  t: (key: string) => string,
): string => {
  const configuration =
    parseConnectionConfiguration<SharePointConfigurationValidationModel>(
      editingConnection.configuration,
    );

  if (!configuration.doneStatus || !configuration.statusesToLoad?.length) {
    return "";
  }

  return configuration.statusesToLoad.includes(configuration.doneStatus)
    ? t(
        "board.connections.dialog.sourceSettings.sharepoint.statusReferenceError",
      )
    : "";
};
